export default __webpack_public_path__ + "static/Advantage-e3e3cc1de54ca7116d5772409c4b0741.png";